/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Foot_LinkInputs */

const en_tut_foot_link = /** @type {(inputs: Tut_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial`)
};

const id_tut_foot_link = /** @type {(inputs: Tut_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial`)
};

/**
* | output |
* | --- |
* | "Tutorial" |
*
* @param {Tut_Foot_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_foot_link = /** @type {((inputs?: Tut_Foot_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Foot_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_foot_link(inputs)
	return en_tut_foot_link(inputs)
});